import clsx from 'clsx';
import { default as MUITooltip, TooltipProps as MUITooltipProps } from '@material-ui/core/Tooltip';
import './Tooltip.css';

//
// --- Types ---

export interface TooltipProps extends MUITooltipProps {}

//
// --- Tooltip Component ---

const Tooltip: React.FC<TooltipProps> = ({ classes = {}, ...remainingTooltipProps }) => {
  const { tooltip: tooltipClassName, ...remainingTooltipClassNames } = classes;

  return (
    <MUITooltip
      classes={{ tooltip: clsx('tooltip', tooltipClassName), ...remainingTooltipClassNames }}
      {...remainingTooltipProps}
    />
  );
};

export default Tooltip;
